.float-group {
  position: relative;
  width: 100%;
}

.float-control {
  width: 100%;
  height: 46px;
  //   padding: 10px 24px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
  padding-left: 22px;
  background-size: 18px 18px;
  background-color: white;
  border: 0.5px solid #c0cee0;
  border-radius: 4px;
  color: black;

  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  box-shadow: inset 0 0.5px 0.5px rgba(0, 0, 0, 0.075);

  //   &:hover {
  //     border-color: #4596e8;
  //   }

  &:focus {
    border-color: #4596e8;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(69, 150, 232, 0.6);
  }

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #999999;
    opacity: 1; /* Firefox */
    font-size: 15px;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999999;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #999999;
  }
}

.float-group .float-control {
  position: relative;
  z-index: inherit;
  float: inherit;
  width: 100%;
  margin-bottom: 0;
}

.float-control:focus {
  border-color: #757575;
  outline: none;
  box-shadow: none;
}

/* -- label styles ---------------------------------- */

.label {
  color: #999999;
  opacity: 1; /* Firefox */
  font-size: 15px;
  pointer-events: none;
  position: absolute;
  font-weight: 400;

  left: 15px;
  top: 5px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

@media (min-width: 768px) {
  .form-horizontal .control-label {
    font-size: 16px;
  }
}

.float-label {
  left: 15px;
  top: 12px;
  padding-left: 10px;
  pointer-events: none;
  padding-right: 7px;
  padding-left: 7px;
}

.float-active {
  top: -7px;
  font-size: 12px;
  //   left: 0px;
  left: 15px;
  padding-right: 7px;
  padding-left: 7px;
  background-color: white;
}

/* -- bar styles -------------------------------------- */

.form-bar {
  position: relative;
  display: block;
  width: 100%;
}

.form-bar::before,
.form-bar::after {
  content: '';
  height: 1px;
  width: 0;
  bottom: 0;
  position: absolute;
  transition: 0.3s ease all;
  -moz-transition: 0.3s ease all;
  -webkit-transition: 0.3s ease all;
}

/* active state */

.float-control:focus ~ .form-bar::before,
.float-control:focus ~ .form-bar::after {
  width: 100%;
}

/* -- highlighter styles ------------------------------ */

.form-highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 30%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

.error-label {
  font-size: 11px;
  color: red;
  margin-top: 6px;
  text-align: center;
}

/* active state */

// .float-control:focus~.form-highlight {
//     -webkit-animation: inputHighlighter 0.3s ease;
//     -moz-animation: inputHighlighter 0.3s ease;
//     animation: inputHighlighter 0.3s ease;
// }

// /* -- highlighter animation --------------------------- */

// @-webkit-keyframes inputHighlighter {
//     from {
//         background: #5264AE;
//     }
//     to {
//         width: 0;
//         background: transparent;
//     }
// }

// @-moz-keyframes inputHighlighter {
//     from {
//         background: #5264AE;
//     }
//     to {
//         width: 0;
//         background: transparent;
//     }
// }

// @keyframes inputHighlighter {
//     from {
//         background: #5264AE;
//     }
//     to {
//         width: 0;
//         background: transparent;
//     }
// }



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/SignUpPage/components/FloatingInput.less